<div class="error-container">
  <mat-icon svgIcon="lock-outline"></mat-icon>
  <h1 class="title">Access Denied</h1>
  <p class="subtitle">You do not have the necessary permissions to view this page.</p>
</div>
